import { Info } from "lucide-react";
import type { FC } from "react";

import { m } from "@recobra/i18n/messages";
import { Tooltip, TooltipContent, TooltipTrigger } from "@recobra/ui/tooltip";

export const AiReasoningTooltip: FC<{ reasoning: string }> = ({ reasoning }) => (
  <>
    <span className="sr-only">
      {m.ai_analysis_reasoning()}: {reasoning}
    </span>
    <Tooltip>
      <TooltipTrigger
        render={
          <span
            className="flex size-4 items-center justify-center rounded-full text-info hover:text-info/80"
            aria-hidden="true"
            tabIndex={-1}
          />
        }
      >
        <Info className="size-3.5" />
      </TooltipTrigger>
      <TooltipContent
        side="top"
        align="start"
        className="max-w-72 flex-col items-start whitespace-pre-wrap"
      >
        <span className="font-medium">{m.ai_analysis_reasoning()}</span>
        <span>{reasoning}</span>
      </TooltipContent>
    </Tooltip>
  </>
);
